module.exports = __webpack_public_path__ + "img/wompi.fbc3a02a.png";